import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { PersonPlate } from './PersonPlate';
import styles from './PersonCell.scss';

export const PersonCell = ({ booking, people, isGroup, role }) => {
  const { clients } = useSelector((state) => state.clients);

  return (
    <div
      className={cn(styles.tableCell, {
        [styles.participants]: role === 'client',
        [styles.centered]: isGroup || people.length === 1,
      })}
    >
      {role === 'client' && isGroup ? (
        <span className={styles.group}>
          {booking.group?.isClub && <FontAwesomeIcon icon={faStar} />} {booking.group?.name}
        </span>
      ) : (
        <div className={styles.list}>
          {people.map((p) => {
            const updatedPerson =
              role === 'client' ? { ...p, balance: clients.find((c) => c.id === p.id)?.balance || 0 } : p;

            return <PersonPlate bookingDate={booking.date} person={updatedPerson} key={p.id} role={role} />;
          })}
        </div>
      )}
    </div>
  );
};
